export const STATE_ACCEPTED = 3;
export const STATE_TO_LIQUIDATE = 6;
export const STATE_FINALIZED = 7;
